import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { adminPrimaryButtonClass } from "./adminStyles";

type AdminListToolbarProps = {
  children?: ReactNode;
  addTo?: string;
  addLabel?: string;
  actions?: ReactNode;
};

export default function AdminListToolbar({
  children,
  addTo,
  addLabel = "Add",
  actions,
}: AdminListToolbarProps) {
  if (!children && !addTo && !actions) return null;

  return (
    <div className="flex flex-wrap items-center justify-between gap-4">
      {children ? <div className="min-w-0 flex-1 max-w-md">{children}</div> : <div />}
      <div className="flex flex-wrap items-center gap-3">
        {actions}
        {addTo && (
          <Link to={addTo} className={adminPrimaryButtonClass}>
            {addLabel}
          </Link>
        )}
      </div>
    </div>
  );
}
